// Presence dots for the open file: remote members' awareness states,
// name only, no cursor (web-viewer spec §Behavior).

import { useEffect, useState } from "react";
import type { PresenceEntry, ViewerSync } from "../viewerSync";

// Fixed tint palette (dynamic color can't be an inline style under the CSP).
const DOT_CLASSES = ["pdot-a", "pdot-b", "pdot-c", "pdot-d", "pdot-e"];

export function PresenceDots({ sync, docId }: { sync: ViewerSync; docId: string }) {
  const [peers, setPeers] = useState<PresenceEntry[]>(() => sync.presence(docId));

  useEffect(() => {
    setPeers(sync.presence(docId));
    return sync.onPresence(docId, () => setPeers(sync.presence(docId)));
  }, [sync, docId]);

  if (peers.length === 0) return null;
  return (
    <span className="flex items-center" aria-label={`${peers.length} other viewer(s)`}>
      {peers.map((p) => (
        <span
          key={p.clientId}
          className={`presence-dot ${DOT_CLASSES[p.clientId % DOT_CLASSES.length]}`}
          title={p.name}
        >
          {p.name.slice(0, 1).toUpperCase()}
        </span>
      ))}
    </span>
  );
}
